import { Injectable } from '@angular/core';
import { SoftwareArtifactReleaseType } from '@nimmsta/ng-commons-lib/models';
import { WorkflowDataService } from '@nimmsta/ng-commons-lib/data-access';

@Injectable({
  providedIn: 'root',
})
export class SoftwareArtifactReleaseTypeService extends WorkflowDataService<SoftwareArtifactReleaseType> {
  protected override get apiEndpoint(): string {
    return '/softwareArtifactReleaseTypes';
  }
}
